// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__om_KX","cardContent":"styles_cardContent___jVjx","scroll":"styles_scroll__3zsud","contents":"styles_contents__2n234","hoverHint":"styles_hoverHint__21CLr"};